import React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import PropertyPickerVertical from './components/PropertyPickerVertical';
import BaseFeature from './BaseFeature';
import { NOMINAL_DATA } from '../../../../../../utils/constantFeatures';

class NominalData extends BaseFeature {

    constructor() {
        super();

        this.state = {};
        
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        this.props.handleChange(propertyName, value);
    }

    render() {
        
        const moduleTemperatureAmbient = this.props.properties[NOMINAL_DATA.moduleTemperatureAmbient];
        const moduleTemperatureCh0 = this.props.properties[NOMINAL_DATA.moduleTemperatureCh0];
        const moduleTemperatureCh1 = this.props.properties[NOMINAL_DATA.moduleTemperatureCh1];
        const operatingCurrentCh0 = this.props.properties[NOMINAL_DATA.operatingCurrentCh0];
        const operatingCurrentCh1 = this.props.properties[NOMINAL_DATA.operatingCurrentCh1];
        const ratedVoltageCh0 = this.props.properties[NOMINAL_DATA.ratedVoltageCh0];
        const ratedVoltageCh1 = this.props.properties[NOMINAL_DATA.ratedVoltageCh1];
        const luminousFluxCh0 = this.props.properties[NOMINAL_DATA.luminousFluxCh0];
        const luminousFluxCh1 = this.props.properties[NOMINAL_DATA.luminousFluxCh1];
        const colourCoordinateXCh0 = this.props.properties[NOMINAL_DATA.colourCoordinateXCh0];
        const colourCoordinateXCh1 = this.props.properties[NOMINAL_DATA.colourCoordinateXCh1];
        const colourCoordinateYCh0 = this.props.properties[NOMINAL_DATA.colourCoordinateYCh0];
        const colourCoordinateYCh1 = this.props.properties[NOMINAL_DATA.colourCoordinateYCh1];

        const physicalColdest = this.props.properties[NOMINAL_DATA.physicalColdest]
            ? this.props.properties[NOMINAL_DATA.physicalColdest]
            : this.props.properties[NOMINAL_DATA.physicalColdestK];
        const physicalWarmest = this.props.properties[NOMINAL_DATA.physicalWarmest]
            ? this.props.properties[NOMINAL_DATA.physicalWarmest]
            : this.props.properties[NOMINAL_DATA.physicalWarmestK];

        const pc = physicalColdest ? {...physicalColdest} : {"info":{"name":"PhysicalCoolest","displayName":null,"unit":"K"},"valueMeta":{"min":"1000","max":"10000"}};
        const pw = physicalWarmest ? {...physicalWarmest} : {"info":{"name":"PhysicalWarmest","displayName":null,"unit":"K"},"valueMeta":{"min":"1000","max":"10000"}};
            
        pc.value = '' + this.getColor(colourCoordinateXCh0.value, colourCoordinateYCh0.value);
        pw.value = '' + this.getColor(colourCoordinateXCh1.value, colourCoordinateYCh1.value);

        console.log(this.props.properties);

        return (
            <div>
                <div className="flex-row">
                    <Card className={this.getClassName([moduleTemperatureAmbient])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Ambient'}
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                            <PropertyPickerVertical
                                property={moduleTemperatureAmbient}
                                border={'border-none'}
                                title={"Module Temperature Ambient"}
                                measureUnit={moduleTemperatureAmbient.info.unit}
                                min={moduleTemperatureAmbient.valueMeta.min}
                                max={moduleTemperatureAmbient.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([moduleTemperatureCh0, operatingCurrentCh0, ratedVoltageCh0, luminousFluxCh0, colourCoordinateXCh0, colourCoordinateYCh0, physicalColdest])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Cold White CH1'}
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                            <PropertyPickerVertical
                                property={moduleTemperatureCh0}
                                border={'border-none'}
                                title={"Module Temperature"}
                                measureUnit={moduleTemperatureCh0.info.unit}
                                min={moduleTemperatureCh0.valueMeta.min}
                                max={moduleTemperatureCh0.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={operatingCurrentCh0}
                                border={'left'}
                                title={"Operating Current"}
                                measureUnit={operatingCurrentCh0.info.unit}
                                min={operatingCurrentCh0.valueMeta.min}
                                max={operatingCurrentCh0.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={ratedVoltageCh0}
                                border={'left'}
                                title={"Rated Voltage"}
                                type={'float'}
                                step={0.01}
                                measureUnit={ratedVoltageCh0.info.unit}
                                min={ratedVoltageCh0.valueMeta.min}
                                max={ratedVoltageCh0.valueMeta.max}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={luminousFluxCh0}
                                border={'left'}
                                title={"Luminous Flux"}
                                measureUnit={luminousFluxCh0.info.unit}
                                min={luminousFluxCh0.valueMeta.min}
                                max={luminousFluxCh0.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={colourCoordinateXCh0}
                                border={'left'}
                                title={"Colour Coordinate x"}
                                measureUnit={colourCoordinateXCh0.info.unit}
                                min={colourCoordinateXCh0.valueMeta.min}
                                max={colourCoordinateXCh0.valueMeta.max}
                                type={'float'}
                                step={0.0001}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={colourCoordinateYCh0}
                                border={'left'}
                                title={"Colour Coordinate y"}
                                measureUnit={colourCoordinateYCh0.info.unit}
                                min={colourCoordinateYCh0.valueMeta.min}
                                max={colourCoordinateYCh0.valueMeta.max}
                                type={'float'}
                                step={0.0001}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={pc}
                                border={'left'}
                                disabled={true}
                                title={'Colour Temperature'}
                                measureUnit={pc.info.unit}
                                min={pc.valueMeta.min}
                                max={pc.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />                        
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([moduleTemperatureCh1, operatingCurrentCh1, ratedVoltageCh1, luminousFluxCh1, colourCoordinateXCh1, colourCoordinateYCh1, physicalWarmest])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Warm White CH2'}
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                            <PropertyPickerVertical
                                property={moduleTemperatureCh1}
                                border={'border-none'}
                                title={"Module Temperature"}
                                measureUnit={moduleTemperatureCh1.info.unit}
                                min={moduleTemperatureCh1.valueMeta.min}
                                max={moduleTemperatureCh1.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={operatingCurrentCh1}
                                border={'left'}
                                title={"Operating Current"}
                                measureUnit={operatingCurrentCh1.info.unit}
                                min={operatingCurrentCh1.valueMeta.min}
                                max={operatingCurrentCh1.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={ratedVoltageCh1}
                                border={'left'}
                                title={"Rated Voltage"}
                                type={'float'}
                                step={0.01}
                                measureUnit={ratedVoltageCh1.info.unit}
                                min={ratedVoltageCh1.valueMeta.min}
                                max={ratedVoltageCh1.valueMeta.max}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={luminousFluxCh1}
                                border={'left'}
                                title={"Luminous Flux"}
                                measureUnit={luminousFluxCh1.info.unit}
                                min={luminousFluxCh1.valueMeta.min}
                                max={luminousFluxCh1.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={colourCoordinateXCh1}
                                border={'left'}
                                title={"Colour Coordinate x"}
                                measureUnit={colourCoordinateXCh1.info.unit}
                                min={colourCoordinateXCh1.valueMeta.min}
                                max={colourCoordinateXCh1.valueMeta.max}
                                type={'float'}
                                step={0.0001}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={colourCoordinateYCh1}
                                border={'left'}
                                title={"Colour Coordinate y"}
                                measureUnit={colourCoordinateYCh1.info.unit}
                                min={colourCoordinateYCh1.valueMeta.min}
                                max={colourCoordinateYCh1.valueMeta.max}
                                type={'float'}
                                step={0.0001}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={pw}
                                border={'left'}
                                title={'Colour Temperature'}
                                disabled={true}
                                measureUnit={pw.info.unit}
                                min={pw.valueMeta.min}
                                max={pw.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />                     
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NominalData);